import StarterKit from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extensions';
import { Markdown } from 'tiptap-markdown';
/**
 * The editing schema for campaign descriptions.
 *
 * The enabled marks and nodes are deliberately the intersection of what
 * `<MarkdownPreview>`'s sanitise schema and the backend `MarkdownExtension`
 * allow: paragraphs, hard breaks, bold, italic, strike, links, both list
 * kinds, blockquote and inline code. Headings, horizontal rules, images and
 * fenced code blocks are switched off at the schema level rather than merely
 * hidden from the toolbar — otherwise a paste or a markdown import could
 * introduce a node the public page then drops, silently losing the user's
 * text between the editor and the page it is written for.
 *
 * Content is read and written as **markdown**, so the storage format is
 * unchanged from the textarea this editor replaces.
 */
export function richTextExtensions(placeholder) {
    return [
        StarterKit.configure({
            heading: false,
            horizontalRule: false,
            codeBlock: false,
            link: {
                openOnClick: false,
                autolink: true,
                protocols: ['http', 'https', 'mailto', 'tel'],
                HTMLAttributes: {
                    rel: 'noopener nofollow',
                    target: '_blank',
                },
                // Mirrors the sanitiser: a `javascript:` or `data:` href never
                // becomes a link mark in the first place.
                isAllowedUri: (url, ctx) => ctx.defaultValidate(url),
            },
        }),
        Markdown.configure({
            // Raw HTML in the source is not rendered — the same stance
            // MarkdownExtension takes server-side.
            html: false,
            transformPastedText: true,
            transformCopiedText: true,
            linkify: false,
            breaks: false,
        }),
        Placeholder.configure({ placeholder: placeholder ?? '' }),
    ];
}
